import {
	create_div,
	set_cookie,
	is_elementor_edit,
	get_cookie,
} from 'src/js/utils';

const footer = document.querySelector('.site_footer');
const cta = document.querySelector('.footer_sticky_cta');

function init() {
	if (!cta) return;

	if (is_elementor_edit()) return;

	if (get_cookie('footer_sticky_cta_close')) {
		// return cta.remove();
		return (cta.style.display = 'none');
	}

	cta.classList.add('init');

	init_styles();
	init_close_button();
}
init();

function init_styles() {
	cta.style.display = 'none';
	cta.style.transform = 'translateY(calc(100% + 30px))';

	setTimeout(() => {
		cta.style.display = '';
		// add padding to footer
		footer.style.paddingBottom = cta.offsetHeight + 'px';
		cta.classList.add('init');
	});

	setTimeout(show, 2000);
}

function init_close_button() {
	const close_button = create_div('close_button', cta);
	close_button.addEventListener('click', hide);
}

function hide() {
	set_cookie('footer_sticky_cta_close', 1, 24);
	cta.style.transform = 'translateY(calc(100% + 30px))';
	footer.style.paddingBottom = '';
}

function show() {
	cta.style.transform = 'translateY(0)';
}
